import React from "react";
import "./meet.css";

function Founder() {
  return (
    <div className="founder-container">

      {/* Heading */}
      <div className="founder-header">
        <h1 className="founder-title">The People Behind the Vision</h1>
        <p className="founder-subtitle">
          Meet the minds building the future of travel experiences
        </p>
      </div>

      {/* CEO Section */}
      <div className="founder-section founder-ceo">

        {/* CEO Gallery */}
        <div className="founder-ceo-gallery">
          <img src="/img/company/destination expert.png" className="founder-img large" />
          <img src="/img/company/me1dslr.jpeg" className="founder-img small" />
          <img src="/img/company/mewith.jpeg" className="founder-img small" />
        </div>

        {/* CEO Content */}
        <div className="founder-content">
          <h2 className="founder-name">CEO & Co-Founder</h2>
          <p className="founder-rol">
            Er Bishnu Prasad Pandey
          </p>
          <p className="founder-role">
            BE Electrical Engineering — Tsinghua University
          </p>

          <p className="founder-message">
            "Travel is more than movement — it's connection, discovery, and trust.
            Our mission is to simplify tourism by solving real problems travelers face:
            fragmented bookings, lack of transparency, and logistical challenges.

            We are building a platform where everything — from hotels and flights
            to guides and activities — exists in one seamless ecosystem. Our focus
            is not just convenience, but reliability, affordability, and human support.

            For over the years, the tourism industry has lacked integration.
            We are changing that by making travel smarter, safer, and more accessible
            for everyone."
          </p>
        </div>
      </div>


      

    </div>
  );
}

export default Founder;